import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { MediaCategoryNames } from '../../models/media/media-category-name';
import { SettingsService } from '../../services/settings.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-media-category-names-popup',
  templateUrl: './media-category-names-popup.component.html',
  styleUrls: ['./media-category-names-popup.component.scss']
})
export class MediaCategoryNamesPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public data: any;
  public isLoader: boolean;
  form: FormGroup;
  @ViewChild(MatTable) _matTables: any;
  public dataSource: MatTableDataSource<MediaCategoryNames>;
  public displayedColumns$ = new BehaviorSubject([
    'alternateName',
    'comments',
    'action'
  ]);
  constructor(public readonly modal: NgbActiveModal, private readonly settingService: SettingsService, private formBuilder: FormBuilder) {
    super();
  }

  public loadMediaCategoryName(): void {
    this.isLoader = true;
    this.settingService.getMediaCategoryNamesAsFormArray(this.data.category.id).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isLoader = false;
      this.form.setControl('mediaCategoryNames', response);
    });
  }
  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  ngOnInit(): void {
    this.form = this.formBuilder.group({
      mediaCategoryNames: this.formBuilder.array([])
    });
    this.loadMediaCategoryName();
  }
  get mediaCategoryNames(): FormArray {
    return this.form.get('mediaCategoryNames') as FormArray;
  }
  addRow(): void {
    const newRow = MediaCategoryNames.asFormGroup({
      alternateName: '',
      comments: '',
      isActive: true,
      mediaCategoryId: this.data.category.id,
      mediaCategoryNameId: 0
    });
    this.mediaCategoryNames.push(newRow);
    this._matTables.renderRows();
  }
  delete(categoryName: FormGroup, index: number): void {
    const control = <FormArray>this.form.controls['mediaCategoryNames'];
    control.removeAt(index);
    this._matTables.renderRows();
    if (categoryName.value.mediaCategoryNameId > 0) {
      this.settingService.deleteMediaCategoryNames(categoryName.value.mediaCategoryNameId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {

      });
    }
  }
  
  saveMediaCategoryName(): void {
    this.isLoader = true;
    const mediaCategoryNames = this.mediaCategoryNames.value;
    this.settingService.saveMediaCategoryNames(mediaCategoryNames).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isLoader = false;
      this.modal.close(this.data);
    });
  }

}
